import React, { useContext } from 'react'
import { AuthContext, AuthContextType } from './contexts/authContext'
import { Routes } from './routes'

interface INWindow extends Window {
    navigation: {
        currentEntry: {
            id: string | null
        }
    }
}

function App(): React.ReactElement {
    const [tabId, setTabId] = React.useState<string | null>(null)
    const { logout } = useContext(AuthContext) as AuthContextType

    React.useEffect(() => {
        const newWindow = window as unknown as INWindow
        if (newWindow.navigation) {
            setTabId(newWindow.navigation.currentEntry.id)
            localStorage.setItem('tabId', newWindow.navigation.currentEntry.id ?? '')
        }
    }, [])

    window.addEventListener('storage', (e) => {
        const key = 'key' in e
        if (key) {
            if (e.key === null && e.oldValue === null && e.newValue === null) {
                logout()
            } else {
                if (tabId && tabId !== localStorage.getItem('tabId')) {
                    const win = window.open('about:blank', '_self')
                    win?.close()
                } else if (tabId) {
                    if (e.oldValue === null) localStorage.removeItem(e.key ?? '')
                    else localStorage.setItem(e.key ?? '', e.oldValue)
                }
            }
        }
    })

    return <Routes />
}

export default App
